module.exports = __webpack_public_path__ + "img/C-POWER_DC-DC300W_ALL.015f6623.jpg";